<template>
	<section class="view-venue-notfound not-exists">
		<ChalkyUiPageHero
			description="We could not find the place you're looking for."
			title="Not Found"
			v-bind:imageUrl="$asset('image/graphic/hero-404.avif')"
		/>

		<!-- Feature: Venues Nearby -->
		<ViewVenueNearby
			v-bind:grid="true"
			v-bind:venueCollection="venueCollection"
			v-bind:venueModel="venueModel"
			v-if="showNearby"
			v-on:venue:select="Handle_OnSelectVenue"
		/>

		<section class="padded default-panel text-center">
			<p class="padded push-bottom type-large-paragraph">
				If you don't see anything you like, you can return home and try again.
			</p>

			<RouterLink class="button button-primary" to="/">Return Home</RouterLink>
		</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Displays a 404 not found state for venues with nearby alternatives.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueNotFound extends ViewBase {
		/**
		 * The venue model used for location-based nearby suggestions
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;

		/**
		 * Collection of nearby venues to display as alternatives
		 *
		 * @type ChalkySticks.Collection.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.collection(),
		})
		public venueCollection!: ChalkySticks.Collection.Venue;

		/**
		 * Whether to show the nearby venues section
		 *
		 * @type boolean
		 */
		@Prop({
			default: false,
		})
		public showNearby!: boolean;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Emits the selected venue to the parent component
		 *
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return void
		 */
		protected Handle_OnSelectVenue(venueModel: ChalkySticks.Model.Venue): void {
			this.$emit('venue:select', venueModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-venue-notfound {
		.view-layout-moduleheader {
			margin-bottom: 0;
		}
	}
</style>
